module.exports = __webpack_public_path__ + "static/media/ig18.bb04817e.jpg";